import formTmp from './form';
import accountInfoTmp from './account-info';
import * as taxPayment from '../tax-payment';
import * as helpers from '../helpers';
import { Slider } from "efile-ui/src/js/slider";

// const canPay = helpers.getVariable('paytax_2019') ? true : false;
const canPay = true;
let swiper = null;
const peselLength = 11;
const nipLength = 10;
const typeName = { 1: 'PESEL', 2: 'NIP' };

const clearErrors = (className) => {
  const element = document.querySelector(`.${className}`);
  const items = element.querySelectorAll('.error:not(.form-group)');
  if (!items) return false;

  const itemsLength = items.length;

  for (let i = 0; i < itemsLength; i++) {
    items[i].parentNode.classList.remove('error');
    items[i].parentNode.removeChild(items[i])
  }
};

const clearTemp = () => {
  const info = document.querySelector('.row-temp');
  if (!info) return false;

  info.parentNode.removeChild(info)
};

const copyAccount = (account) => {
  const textarea = document.createElement('textarea');
  textarea.value = account.replace(/(<([^>]+)>)|\s/g,'');
  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('Copy');
  document.body.removeChild(textarea);
};

const fillAgain = () => {
  const { slider } = swiper;
  const form = document.querySelector('#microaccount-form');
  if (!form) return false;

  taxPayment.fillAgain();

  form.reset();
  slider.slidePrev();
  microaccountInfoRemoveEvents();
  setTimeout(() => { slider.removeSlide(1) }, 500);
};

const showAccount = (type, id, account) => {
  const { slider } = swiper;

  slider.appendSlide(`
    <div class="swiper-slide">
        <div>${accountInfoTmp(type, id, account, canPay)}</div>
    </div>
  `);

  setTimeout(() => {
    microaccountInfoAddEvents(account, type, id);
    slider.slideNext();

    if (canPay) taxPayment.init(type, id, account);
  }, 50);
};

const microaccountInfoAddEvents = (account, type, id) => {
  const accountInfo = document.querySelector('.microaccount-account-info');

  accountInfo.querySelector('.copy-element').addEventListener('click', () => copyAccount(account.raw));
  accountInfo.querySelector('.fill-again').addEventListener('click', () => fillAgain());

  if (canPay) {
    // accountInfo.querySelector('.show-pay-form').addEventListener('click', () => taxPayment.showPanel());
    accountInfo.querySelector('.show-pay-form').addEventListener('click', () => goToTaxPayment(account, type, id));
  }
};

const microaccountInfoRemoveEvents = () => {
  const accountInfo = document.querySelector('.microaccount-account-info');

  accountInfo.querySelector('.copy-element').removeEventListener('click', () => copyAccount(account.raw));
  accountInfo.querySelector('.fill-again').removeEventListener('click', () => fillAgain());

  if (canPay) {
    // accountInfo.querySelector('.show-pay-form').removeEventListener('click', () => taxPayment.showPanel());
    accountInfo.querySelector('.show-pay-form').removeEventListener('click', () => goToTaxPayment());
  }
};

const goToTaxPayment = (account, type, id) => {
  // console.log('account', account, type, id);

  const selectedType = typeName[type].toLowerCase();

  const form = document.createElement('form');
  form.method = 'post';
  form.action = 'https://mikrorachunek.pl/platnosci/';
  form.classList.add('d-none');

  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = selectedType;
  input.value = id;

  form.appendChild(input);
  document.body.appendChild(form);
  form.submit();
}

const addZeros = (n) => {
  const s = n.toString();

  if (s.length == 1) return '0' + s;
  return s;
};

const iban = (account) => {
  account = account.trim();

  const _number = account + "252100";
  const _numberLength = _number.length;
  let modulo = 0;

  for (let i = 0; i < _numberLength; i++) {
    modulo = (10 * modulo + parseInt(_number.substr(i, 1))) % 97;
  }

  modulo = 98 - modulo;

  return addZeros(modulo) + account;
};

export const isIdCorrect = (type, id) => {
  if (id === '') return false;

  const idLenght = id.length;
  let sum = 0;
  let checksum = 0;
  let modulo = 0;
  let weights = null;
  let weightsLength = 0;

  // type = 1 = PESEL
  if (type === 1) {
    modulo = 10;
    if (idLenght !== peselLength) return false;

    weights = [9, 7, 3, 1, 9, 7, 3, 1, 9, 7];
  }
  // type = 2 = NIP
  else if (type === 2) {
    modulo = 11;
    if (idLenght !== nipLength) return false;

    weights = [6, 5, 7, 2, 3, 4, 5, 6, 7];
  } else return false;

  weightsLength = weights.length;
  checksum = parseInt(id.substr(idLenght - 1, 1));

  for (let i = 0; i < weightsLength; i++) {
    sum += weights[i] * parseInt(id.substr(i, 1));
  }

  sum = sum % modulo;
  // console.log('CHECK', 'sum: ' + sum, 'checksum: ' + checksum);

  if (sum === checksum) return true;

  return false;
};

const prepareBetterAccountNumber = (account) => {
  account = 'PL' + account;
  const accountLength = account.length;
  const length = 4;
  let preparedAccount = '';

  for (let i = 0; i < accountLength; i++) {
    if (i > 0) preparedAccount += ' ';
    preparedAccount += account.substr((i * length),length)
  }

  return preparedAccount;
};

export const prepareAccountNumber = (type, id) => {
  // var type:number = 1 (PESEL) | 2 (NIP)
  type = parseInt(type);

  // 10100071 - numer rozliczeniowy w NBP
  // 222      - numer uzupełniający w NBP
  let accountNumber = '10100071222';

  const test = /\D+/.test(id);
  if (test) return helpers.error('Niepoprawny znak');
  else if ((type === 1 && id.length !== peselLength) || (type === 2 && id.length !== nipLength)) {
    return helpers.error('Niepoprawny numer identyfikatora', 'id');
  }

  accountNumber += type.toString();
  accountNumber += (type === 1) ? id + '0' : id + '00';

  const ibanNumber = iban(accountNumber);

  let preparedNumber = prepareBetterAccountNumber(ibanNumber);

  const toCut = preparedNumber.substr(20, (type === 1 ? peselLength : nipLength) + 2);
  preparedNumber = preparedNumber.replace(toCut, `<span class="microaccount-your-id">${toCut}</span>`);

  // console.log('INDEX', preparedNumber, toCut);
  // console.log('TEST', typeof id, parseInt(id), accountNumber);
  // console.log('Better', prepareBetterAccountNumber(ibanNumber));

  return {
    html: preparedNumber,
    raw: ibanNumber
  };
};

const isMicroaccountFormExist = () => {
  const microaccountForm = document.querySelector('#microaccount-form');

  if (microaccountForm) {
    const { slider } = swiper;
    manualCheckIdField();
    addEventOnType();
    microaccountForm.addEventListener('submit', (e) => {
      e.preventDefault();

      clearErrors('microaccount-form');
      clearTemp();

      const elements = e.target.elements;
      const elementsLength = elements.length;

      if (elementsLength > 0) {
        let type = 0;
        let id = '';

        for (let i = 0; i < elementsLength; i++) {
          if (elements[i].name === 'type') type = parseInt(elements[i].value);
          if (elements[i].name === 'id') id = elements[i].value;
        }

        if (isIdCorrect(type, id)) {
          const accountNumber = prepareAccountNumber(type, id);
          if (accountNumber.isError) return false;

          showAccount(type, id, accountNumber);
          // console.log('accountNumber', accountNumber, type, id);
        } else {
          helpers.error('Niepoprawny numer identyfikatora', 'id');
        }
        slider.updateAutoHeight();
      }
    })
  }
};

const addEventOnType = () => {
  const microaccountType = document.querySelector('#microaccount-type');
  if (!microaccountType) return false;

  microaccountType.addEventListener('change', (e) => {
    const type = parseInt(e.target.value);

    if (!isNaN(type)) changeLengthTypeField(type);
    else return false;
  })
};

const manualCheckIdField = () => {
  const microaccountType = document.querySelector('#microaccount-type');
  if (!microaccountType) return false;

  const type = parseInt(microaccountType.value);

  if (!isNaN(type)) changeLengthTypeField(type);
};

const changeLengthTypeField = (type) => {
  const microaccountId = document.querySelector('#microaccount-id');
  const microaccountIdLabel = document.querySelector('label[for="microaccount-id"] span');
  if (!microaccountId || !microaccountIdLabel) return false;

  microaccountIdLabel.innerText = typeName[type];

  if (type === 1) {
    microaccountId.setAttribute('maxlength', peselLength);
    microaccountId.setAttribute('placeholder', 'np. 79010123589');
  }
  else if (type === 2) {
    microaccountId.setAttribute('maxlength', nipLength);
    microaccountId.setAttribute('placeholder', 'np. 7771112233 (bez przerw i myślników)');
  }
};

const runPanel = () => {
  swiper = new Slider('#microaccount-generator', {
    // Start override default
    loop: false,
    slidesPerView: 1,
    autoplay: false,
    // End override default
    allowTouchMove: false,
    autoHeight: true,
    calculateHeight: true,
    speed: 500,
    pagination: {
      clickable: true,
      renderBullet: (index, className) => {
        return '<span class="' + className + '">' + (index + 1) + '</span>';
      }
    },
    forceInit: true
  })
};

const addPanel = () => {
  const panel = helpers.elementExist('#microaccount-generator', true);
  if (!panel) return false;

  panel.classList.add('swiper-container');
  panel.innerHTML = `<div class="swiper-slide">${formTmp}</div>`;

  runPanel();
};

const scrollToElement = (name, offset = 100) => {
  const element = document.querySelector(name);
  if (typeof element === 'undefined' || !element) return false;

  const scrollElement = element.offsetTop;
  window.scrollTo({ top: scrollElement - offset, behavior: 'smooth'});
}

const autoGenerate = () => {
  const id = helpers.getVariable('id_nr');
  if (!id) return false;

  let type = false;

  Object.keys(typeName).forEach(typeNr => {
    const isCorrect = isIdCorrect(parseInt(typeNr), id);
    if (isCorrect) type = parseInt(typeNr);
  });

  if (!type) return false;

  const accountNumber = prepareAccountNumber(type, id);
  if (accountNumber.isError) return false;

  showAccount(type, id, accountNumber);
  scrollToElement(".microaccount-box");
}

export const init = () => {
  addPanel();
  isMicroaccountFormExist();
  taxPayment.isPaymentStatusExist();
  autoGenerate();
};
